export default __webpack_public_path__ + "static/media/content.5ecb5039.csv";